import { useCallback } from "react";
import { useAppDispatch } from "../ducksHook";
import { tierActions } from "../slices/tier.slice";

type ServiceOperators = {
    onClaimTierUpgradeReward: (params: any) => void;
    onSetUnlockedTierRewards: (params: any) => void;
};

const useTierService = (): Readonly<ServiceOperators> => {
  const dispatch = useAppDispatch();

  return {
    onClaimTierUpgradeReward: useCallback(
      (params: any) => dispatch(tierActions.claimTierUpgradeBonusRequest(params)),
      [dispatch]
    ),
    onSetUnlockedTierRewards: useCallback(
      (params: any) => dispatch(tierActions.setUnlockedTierLevels(params)),
      [dispatch]
    )
  };
};

export default useTierService;